// extracted by mini-css-extract-plugin
export var list = "styles-module__list___brdaj";
export var activeDayLight = "styles-module__activeDayLight___jfltR";
export var loadingSpinnerContainer = "styles-module__loadingSpinnerContainer___RlIGa";
export var tabBar = "styles-module__tabBar___Wwhvn";